import React from "react";

interface PortalCardProps {
  portalUid: string;
  onSelect: (portalUid: string) => void;
  disabled?: boolean;
}

export default function PortalCard({
  portalUid,
  onSelect,
  disabled = false,
}: PortalCardProps) {
  return (
    <button
      type="button"
      className="company-card card w-100 text-start border mb-3"
      onClick={() => onSelect(portalUid)}
      disabled={disabled}
      aria-label={`Select ${portalUid}`}
    >
      <div className="card-body d-flex align-items-center gap-3 py-3 px-4">
        <div className="company-card__icon rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
          <span className="fw-bold text-white fs-5" aria-hidden="true">
            {portalUid.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="overflow-hidden">
          <div className="fw-semibold text-dark text-truncate">{portalUid}</div>
          <div className="text-muted small text-truncate">Portal</div>
        </div>
        <div className="ms-auto text-muted">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
    </button>
  );
}
